
const styles = (theme) => ({
  table: {
  },
  tableHead: {
    width: 'calc( 100% - 1em )'
  },
  tableBody: {
    display: 'block',
    maxHeight: 340,
    overflowY: 'auto'
  },
  tableRow: {
    display: 'table',
    width: '100%',
    tableLayout: 'fixed' /* even columns width , fix width of table too*/
  },
  total: {
    fontWeight: 'bold',
    paddingTop: '1rem'
  }
  
})

export {
  styles
}
